import http from '../http'

const API_URL = "eps"

class EPS_API {

  async getAllEPS() {
    const response = await http(`${API_URL}/select`, 'GET')
    return response['Eps'] || []
  }


}

export default new EPS_API()